/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const addCollectionChallengeResponseSchema = createApiResponseSchema() as z.ZodSchema<IAPI>;

export type IAddCollectionChallengeResponse = IAPI;
